import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { trpc } from '@/lib/trpc';
import { LegalPage } from './-components/legal-page';
import { slugs } from './selection-criteria.meta';

export const Route = createFileRoute('/new/selection-criteria')({
	loader: ({ context }) => {
		context.queryClient.prefetchQuery(
			trpc.core.getLegalContent.queryOptions({ type: 'selection-criteria', locale: context.locale }),
		);
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();
	return (
		<LegalPage
			type="selection-criteria"
			slugs={slugs}
			title={t`Selection Criteria - Worldcoo`}
			description={t`The requirements a social entity and its project must meet to be funded through Worldcoo's fundraising channels.`}
		/>
	);
}
